function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}
const isMobile = isMobileDevice();


var z5SectionV1Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    var multiple = 3

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.line-bg img'), {
                opacity:0,
                duration:30 * multiple
            }, 0 * multiple)
            .to(section.find('.line-bg'), {
                opacity:0,
                duration:20 * multiple
            }, 40 * multiple)

            .to(section.find('.sections-logo'), {
                opacity:1,
                duration:22 * multiple
            },46.6 * multiple)
            .to(section.find('.sections-logo .section-logo-img'), {
                opacity:0,
                scale:2,
                duration:26 * multiple
            },85.6 * multiple)

            
            .to(section.find('.sections-logo .section-logo-star'), {
                opacity:1,
                scale:1,
                duration:1 * multiple
            },81.6 * multiple)
            .to(section.find('.sections-logo .section-logo-star'), {
                scale:100,
                duration:40 * multiple
            },85.2 * multiple)
            .to(section.find('.sections-logo .section-logo-star img'), {
                opacity:0,
                duration:20 * multiple
            },89.2 * multiple)


            .to(section.find('.sections-bg'), {
                opacity:1,
                delay:1 * multiple
            },110 * multiple)
            .from(section.find('.sections-h1'), {
                //y: '10vh',
                duration:4 * multiple,
                opacity:0,
            },115 * multiple)
            .from(section.find('.sections-h2'), {
                //y: '10vh',
                opacity:0,
                duration:4 * multiple,
                delay:.2 * multiple
            },115 * multiple)
            .from(section.find('.sections-h3'), {
                //y: '10vh',
                opacity:0,
                duration:4 * multiple,
                delay:.2 * multiple
            },115 * multiple)
            .from(section.find('.sections-content'), {
                duration:10 * multiple
            },115 * multiple)

            .from(section.find('.sections-delay'), {
                opacity:1,
                duration:30
            },115 * multiple)
    });

};
var z5SectionV1Init = function () {
    var SectionImgAnmi = $('.z5-section-v1');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV1Fn(SectionImgAnmi[i]);
    }
};
z5SectionV1Init();



var z5SectionV2Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.z5-scroll-section-2 .sections-bg'), {
                opacity:0,
                duration:8
            }, 0)
            .from(section.find('.z5-scroll-section-2 .sections-bg .img'), {
                scale:2,
                duration:8
            },0)
            .from(section.find('.title'), {
                opacity:0,
                scale:.5,
                duration:8
            },6.6)
            .from(section.find('.z5-scroll-section-2'), {
                opacity:1,
                duration:10
            },13.6)
    });

};
var z5SectionV2Init = function () {
    var SectionImgAnmi = $('.z5-section-v2');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV2Fn(SectionImgAnmi[i]);
    }
};
z5SectionV2Init();



var z5SectionV3Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.sections-bg'), {
                height:0,
                duration:5,
                delay:3
            }, 0)
            .to(section.find('.content-box'), {
                opacity:1
            }, 9)
            .to(section.find('.menu-box'), {
                opacity:1
            }, 9)
            .to(section.find('.z5-swiper'), {
                duration:13
            }, 0)
    });

};
var z5SectionV3Init = function () {
    var SectionImgAnmi = $('.z5-section-v3');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV3Fn(SectionImgAnmi[i]);
    }
};
if ($(window).width() >= 992) {
z5SectionV3Init();
}




var z5SectionV4Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z5-fade'), {
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.title'), {
                scale:10,
                duration:5
            }, 0)
            .to(section.find('.title'), {
                opacity:0,
                duration:2,
                delay:6
            }, 0)
            .to(section.find('.sections-bg img'), {
                y:"-60%",
                duration:2,
                delay:6
            }, 0)
            .from(section.find('.z5-content'), {
                duration:2,
                y: '10vh',
                opacity:0,
                delay:8
            }, 0)
    });

};
var z5SectionV4Init = function () {
    var SectionImgAnmi = $('.z5-section-v4');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV4Fn(SectionImgAnmi[i]);
    }
};
z5SectionV4Init();








var z5SectionV7Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation:gsap.timeline()
        .to(section.find('.z5-blur-body'), {
            opacity:0,
            duration:2
        }, 2)
        .to(section.find('.z5-blur-bg'), {
            duration:10
        }, 4)
    });

};
var z5SectionV7Init = function () {
    var SectionImgAnmi = $('.z5-section-v7');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV7Fn(SectionImgAnmi[i]);
    }
};
z5SectionV7Init();


var z5SectionV72Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];



    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z5-accordion-center'), {
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });

};
var z5SectionV72Init = function () {
    var SectionImgAnmi = $('.z5-section-v7-swiper');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV72Fn(SectionImgAnmi[i]);
    }
};
//z5SectionV72Init();

var z5SectionFadeFn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.z5-content'), {
                opacity:0,
                //top:"100%",
                duration:2,
                delay:2
            }, 0)
    });

};
var z5SectionFadeInit = function () {
    var SectionImgAnmi = $('.z5-section-fade');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionFadeFn(SectionImgAnmi[i]);
    }
};
if(!isMobile){
z5SectionFadeInit();
}


var z5SectionV8Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.sections-title'), {
                opacity:0,
                duration:2
            }, 0)
            .from(section.find('.z5-content'), {
                opacity:0,
                duration:2,
                delay:2
            }, 0)
    });

};
var z5SectionV8Init = function () {
    var SectionImgAnmi = $('.z5-section-v8');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV8Fn(SectionImgAnmi[i]);
    }
};
z5SectionV8Init();



var z5SectionV10Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: 
        !isMobile?(
            gsap.timeline()
            .from(section.find('.sections-bg'), {
                scale:10,
                duration:10
            }, 0)
            .to(section.find('.sections-bg img'), {
                opacity:0,
                duration:1
            }, 10)
            .from(section.find('.sections-car'), {
                opacity:0,
                duration:1,
                delay:11
            }, 0)
            .from(section.find('.sections-title'), {
                opacity:1,
                duration:3,
                delay:7
            }, 0)
            .from(section.find('.delay-ms'), {
                opacity:0,
                delay:21
            }, 0)
        ):(
            gsap.timeline()
          .from(section.find('.sections-bg'), {
                scale:10,
                duration:10
            }, 0)
            .to(section.find('.sections-bg img'), {
                opacity:0,
                duration:1
            }, 10)
            .from(section.find('.sections-car'), {
                opacity:0,
                duration:1,
                delay:11
            }, 0)
            .from(section.find('.sections-title'), {
                opacity:1,
                duration:3,
                delay:7
            }, 0)
            .from(section.find('.delay-ms'), {
                opacity:0,
                delay:21
            }, 0)
        )
    });

};
var z5SectionV10Init = function () {
    var SectionImgAnmi = $('.z5-section-v10');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionV10Fn(SectionImgAnmi[i]);
    }
};
z5SectionV10Init();





var z5SectionV11Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.to(section.find('.item-box-1'), {
                opacity: 1,y:0,
                duration: 0.3
            }, 0)
    });
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.to(section.find('.item-box-2'), {
                opacity: 1,y:0,
                duration: 0.3,
            }, 0)
    });
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.to(section.find('.item-box-3'), {
                opacity: 1,y:0,
                duration: 0.3,
            }, 0)
    });
};

var z5SectionV11Init = function () {
    var cardGroupV4 = $('.z5-section-v11');
    for (var i = 0; i < cardGroupV4.length; i++) {
        z5SectionV11Fn(cardGroupV4[i]);
    }
};

z5SectionV11Init();






var z5SectionFade2Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.z5-content'), {
                opacity:0,
                //top:"100%",
                duration:2,
                delay:2
            }, 0)
    });

};
var z5SectionFade2Init = function () {
    var SectionImgAnmi = $('.z5-section-fade2');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z5SectionFade2Fn(SectionImgAnmi[i]);
    }
};
z5SectionFade2Init();